/**
 * Clear-all control for the RMA list filters sidebar.
 * Clears applied filters, reloads page 1, and optionally notifies the parent (e.g. close tablet drawer).
 */
import { observer } from "mobx-react";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaListFiltersStore from "../../../../rma-list-page/stores/rma-list-filters-store";
import rmaPagedListStore from "../../../stores/rma-tabs-paged-list-store";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled: boolean;
    onFiltersApplied?: () => void;
}

const RmaListFiltersSidebarClearAll: React.FC<IProps> = observer(
    ({ rmaListFiltersStore, disabled, onFiltersApplied }) => {
        const { getTranslation } = useDashboardTranslation();
        const scope = "dashboard-returns-page";
        const appliedCount = rmaListFiltersStore.appliedWiredSidebarFilterCount;
        const clearAllLabel =
            appliedCount > 0
                ? `${getTranslation("FILTERS_CLEAR_ALL", scope)} (${appliedCount})`
                : getTranslation("FILTERS_CLEAR_ALL", scope);

        const onClearAll = () => {
            rmaListFiltersStore.clearAll();
            rmaPagedListStore.loadPage(1);
            onFiltersApplied?.();
        };

        return (
            <button
                type="button"
                className="rma-list-filters-sidebar__clear-all"
                disabled={disabled || appliedCount === 0}
                onClick={onClearAll}
            >
                <FontBody2 color={FONT_COLOR.ACCENT1}>{clearAllLabel}</FontBody2>
            </button>
        );
    },
);

export default RmaListFiltersSidebarClearAll;
